











import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import Toggle from '@/components/UI/Toggle.vue'

@Component({})
export default class ToggleCheckBox extends Toggle {

}

